import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';

/**
 * "Text me when my order is ready" - the online guest's consent for the one
 * ready text (sent as `sms_notify` on POST /online/{slug}/orders; the kitchen's
 * Ready texts the phone above only when this was ticked). Unchecked by default.
 */
export default function ReadyTextOptIn({ checked, onChange, id = 'sms-notify' }) {
  return (
    <div className="flex items-start gap-3" data-testid="sms-notify-optin">
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(value) => onChange(value === true)}
        className="mt-0.5"
        data-testid="sms-notify-checkbox"
      />
      <div className="space-y-1">
        <Label htmlFor={id} className="text-sm font-medium cursor-pointer">
          Text me when my order is ready
        </Label>
        <p className="text-xs text-muted-foreground">Msg &amp; data rates may apply. Reply STOP to opt out.</p>
      </div>
    </div>
  );
}
